import { render } from "./Vet.vue?vue&type=template&id=f9740e5e&scoped=true&ts=true"
import script from "./Vet.vue?vue&type=script&lang=ts"
export * from "./Vet.vue?vue&type=script&lang=ts"

import "./Vet.vue?vue&type=style&index=0&id=f9740e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9740e5e"]])

export default __exports__